import { Content } from "@/ui";
import SeoHead from "@/components/SeoHead";

// Page Builders
import builderPages from "@/../.sourceflow/dynamic_pages.json";
import DynamicPageSeo from "@/ui/DynamicPageSeo/component";
import ContentBlocks from "@/ui/ContentBlocks/component";

export default function Page({ title, canonical, content, isBuilder = false, seo = {}, data = [] }) {
  return (
    <>
      {isBuilder ? (
        <>
          <DynamicPageSeo
            {...seo}
            title={seo?.title?.length > 0 ? seo.title : title}
            canonical={seo?.canonical?.length > 0 ? seo.canonical : canonical}
          />
          <ContentBlocks data={data} prefix={canonical} />
        </>
      ) : (
        <>
          <SeoHead title={title} canonical={canonical} />
          <Content items={content} />
        </>
      )}
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const slug = url_slugs.join("/");
  const builderPage = builderPages.find((page) => page.url_slug === slug);

  return {
    props: {
      isBuilder: true,
      seo: {
        title: builderPage.seo_title || builderPage.title,
        description: builderPage.seo_description || "",
        canonical: `/${slug}`,
      },
      title: builderPage.title,
      canonical: `/${slug}`,
      data: builderPage.content || [],
    },
  };
}

export async function getStaticPaths() {
  const exclude = ["/"];
  
  const builderPaths = builderPages
  .filter((page) =>
        !page?.is_draft === true &&
        !exclude.includes(page.url_slug)
  )
  .map((page) => {
    return {
      params: {
        url_slugs: page.url_slug.split("/"),
      },
    };
  });

  return {
    paths: [...builderPaths],
    fallback: false,
  };
}
